import React from "react";
import "./strength.scss";
import Img1 from "../../../assets/strategy.svg";
import Img2 from "../../../assets/network.svg";
import Img3 from "../../../assets/team.svg";
import Img4 from "../../../assets/solution.svg";
import { Zoom,Slide } from "react-awesome-reveal";
const Strength = () => {
  return (
    <div className="container str mt-5">
      <div className="row text-center">
        <div className="col-12 heading">
          <Zoom>
          <h2 className="text-white">Our Strengths</h2>
          </Zoom>
        </div>
        <div className="col-12 px-5 str-content">
          <p className="mx-5 my-3 text-white">
            A leading consulting firm, we specialize in providing strategic
            solutions, leveraging industry expertise to drive client success and
            innovation.
          </p>
        </div>
      </div>

      <div className="row my-5">
        <div className="col-lg-3 col-md-6 col-sm-6 col-12">
          <Slide>
          <div className="card card-white">
            <div className="card-body">
              <img
                src={Img1}
                className="card-img-top text-center"
                alt="Strategic Alliance"
              />
              <h5 className="card-title">Strategic Alliance</h5>
              <p className="card-text">
                Formed crucial alliances with global business information
                providers to boost our capabilities.
              </p>
            </div>
          </div>
          </Slide>
        </div>

        <div className="col-lg-3 col-md-6 col-sm-6 col-12">
        <Slide>
          <div className="card card-orange">
            <div className="card-body">
              <img
                src={Img2}
                className="card-img-top"
                alt="Network & Relation"
              />
              <h5 className="card-title text-white">Network & Relation</h5>
              <p className="card-text text-white">
                With a strong network, we foster credible ties with diverse
                lenders, both conventional and unconventional.
              </p>
            </div>
          </div>
          </Slide>
        </div>

        <div className="col-lg-3 col-md-6 col-sm-6 col-12">
        <Slide direction="right">
          <div className="card card-yellow">
            <div className="card-body">
              <img src={Img3} className="card-img-top" alt="..." />
              <h5 className="card-title">Experienced Team</h5>
              <p className="card-text">
                Backed by a seasoned team, we ensure expert handling and
                consistent client satisfaction.
              </p>
            </div>
          </div>
          </Slide>
        </div>

        <div className="col-lg-3 col-md-6 col-sm-6 col-12">
        <Slide direction="right">
          <div className="card card-blue">
            <div className="card-body">
              <img className="card-img-top" src={Img4} alt="" />
              <h5 className="card-title text-white">Proficient Solution</h5>
              <p className="card-text text-white">
                Specializing in diverse finance challenges, we craft custom
                solutions for clients' unique needs, be it short-term or
                strategic.
              </p>
            </div>
          </div>
          </Slide>
        </div>
      </div>
    </div>
  );
};

export default Strength;
